import {
    Box, Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Divider, FormGroup, Paper, Table,
    TableBody, TableCell, TableHead, TableRow, Tooltip, Typography
} from '@material-ui/core';
import api from '../../../services/api';
import React, { Component } from 'react';
import { formatData } from 'lib/functions';
import PerfectScrollBar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { FeedbackOutlined as FeedbackOutlinedIcon } from '@material-ui/icons';

class AgendaEscalaFornecedorForm extends Component {
    state = {
        escala: null,
        itens: [],
        isLoading: true,
        openAlert: false,
        messageAlert: '',
        openObsModal: false,
        obsModalTexto: '',
        obsModalTitulo: ''
    };

    async componentDidMount() {
        const { id } = this.props.match.params;

        try {
            // 1) dados da escala (header)
            const respEscala = await api.get(`/agendaescalafornecedor/${id}`);
            const escala = (respEscala.data && respEscala.data.data && respEscala.data.data[0]) ? respEscala.data.data[0] : null;

            // 2) itens OSs da escala
            const respItens = await api.get(`/agendaescalafornecedor/${id}/itens`);
            const itens = (respItens.data && respItens.data.data) ? respItens.data.data : [];

            this.setState({ escala, itens, isLoading: false });

        } catch (err) {
            console.error(err);
            this.setState({
                escala: null,
                itens: [],
                isLoading: false,
                openAlert: true,
                messageAlert: 'Erro ao carregar detalhes da escala!'
            });
        }
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click voltar */
    onClickVoltar = () => {
        const { history } = this.props;

        if (history && history.goBack) {
            history.goBack();
        }
    };

    /* Abre modal observação */
    handleOpenObsModal = (item) => {
        this.setState({
            openObsModal: true,
            obsModalTexto: item && item.obs ? item.obs : '',
            obsModalTitulo: item && item.coditemos ? `Observação OS ${item.nroos}` : 'Observação'
        });
    };

    /* Fecha modal observação */
    handleCloseObsModal = () => {
        this.setState({
            openObsModal: false,
            obsModalTexto: '',
            obsModalTitulo: ''
        });
    };

    /* Agrupamento por hotel */
    groupByHotel = (itens) => {
        const groups = {};
        (itens || []).forEach((item) => {
            const hotel = item.hotel || 'SEM HOTEL';
            if (!groups[hotel]) groups[hotel] = [];
            groups[hotel].push(item);
        });

        return groups;
    };

    /* Formato para campos hora */
    formatTime = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    render() {
        const {
            escala,
            itens,
            isLoading,
            openAlert,
            messageAlert,
            openObsModal,
            obsModalTitulo,
            obsModalTexto
        } = this.state;

        if (isLoading) {
            return (
                <div style={{ margin: 30 }}>
                    <Typography variant="body1">
                        Carregando...
                    </Typography>
                </div>
            );
        }

        const grupos = this.groupByHotel(itens);
        const hoteisOrdenados = Object.keys(grupos).sort((a, b) => a.localeCompare(b));

        return (
            <div
                style={{
                    marginLeft: 30,
                    marginTop: 30,
                    marginRight: 30
                }}
            >
                <Card>
                    <CardContent>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Typography variant="h5">
                                Escala {escala.coditemescala}
                            </Typography>

                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.onClickVoltar}
                            >
                                Voltar
                            </Button>
                        </Box>

                        <Divider style={{ marginTop: 12, marginBottom: 12 }} />

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            justifyContent="space-between"
                            style={{ gap: 16 }}
                        >
                            <Box
                                style={{
                                    minWidth: 220,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Serviço
                                </Typography>

                                <Typography variant="body1">
                                    {escala.descservico}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    minWidth: 140,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Data
                                </Typography>

                                <Typography variant="body1">
                                    {formatData(escala.dataservico)}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    minWidth: 120,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Hora Serviço
                                </Typography>

                                <Typography variant="body1">
                                    {this.formatTime(escala.horaservico)}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    minWidth: 120,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Total Pax
                                </Typography>

                                <Typography variant="body1">
                                    {escala.totalpax}
                                </Typography>
                            </Box>
                        </Box>

                        <Divider style={{ marginTop: 8, marginBottom: 12 }} />

                        <Typography
                            variant="h6"
                            style={{ marginBottom: 10 }}
                        >
                            Ordens de Serviço Escaladas
                        </Typography>

                        {hoteisOrdenados.length === 0 ? (
                            <Typography variant="body2">
                                Nenhuma OS encontrada para essa escala
                            </Typography>
                        ) : (
                            hoteisOrdenados.map((hotel) => (
                                <Box
                                    key={hotel}
                                    style={{ marginBottom: 18 }}
                                >
                                    <Paper>
                                        <PerfectScrollBar>
                                            <div style={{ minWidth: 900 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">OS</TableCell>

                                                            <TableCell align="center">Titular</TableCell>

                                                            <TableCell align="center">Total Pax</TableCell>

                                                            <TableCell align="center">Hotel</TableCell>

                                                            <TableCell align="center">Hora Apresentação</TableCell>

                                                            <TableCell align="center">Observação</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {grupos[hotel].map((item) => (
                                                            <TableRow
                                                                hover
                                                                key={item.nroos}
                                                            >
                                                                <TableCell align="center">
                                                                    {item.nroos}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.titular}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.totalpax}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.hotel}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {this.formatTime(item.horaapresentacao)}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {(() => {
                                                                        const semObs = !item.obs || item.obs.trim() === '';

                                                                        return (
                                                                            <Tooltip
                                                                                title={semObs ? '' : 'Observação'}
                                                                                enterDelay={50}
                                                                            >
                                                                                <span>
                                                                                    <FeedbackOutlinedIcon
                                                                                        onMouseEnter={(e) => {
                                                                                            if (!semObs) e.currentTarget.style.color = '#1976d2';
                                                                                        }}
                                                                                        onMouseLeave={(e) => {
                                                                                            if (!semObs) e.currentTarget.style.color = '#0000ee';
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (!semObs) this.handleOpenObsModal(item);
                                                                                        }}
                                                                                        style={{
                                                                                            cursor: semObs ? 'default' : 'pointer',
                                                                                            color: semObs ? '#bdbdbd' : '#0000ee'
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                                        );
                                                                    })()}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </PerfectScrollBar>
                                    </Paper>
                                </Box>
                            ))
                        )}
                    </CardContent>
                </Card>

                {/* Modal observação */}
                <Dialog
                    open={openObsModal}
                    onClose={this.handleCloseObsModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>{obsModalTitulo}</DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <FormGroup style={{ marginBottom: 8 }}>
                            <textarea
                                value={obsModalTexto}
                                readOnly
                                tabIndex={-1}
                                style={{
                                    height: 120,
                                    width: '100%',
                                    padding: 12,
                                    border: '1px solid #ccc',
                                    borderRadius: 6,
                                    fontFamily: 'Calibri, sans-serif',
                                    resize: 'none',
                                    pointerEvents: 'none'
                                }}
                            />
                        </FormGroup>
                    </DialogContent>
                </Dialog>

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default AgendaEscalaFornecedorForm;